import { Currency } from '../entity/api/organization-billing';

// TODO: When we fully migrate to the new subscription API, we can remove the Currency enum and use the Currency enum instead
function currencyCodeMap(currency: Currency) {
  switch (currency) {
    case Currency.Eur:
      return 'EUR';
    default:
      return 'USD';
  }
}

export function formatCurrency(amount: number, currency: Currency, userLanguage?: string) {
  const language = userLanguage == 'fr' ? 'fr-FR' : 'en-US';
  const currencyCode = currencyCodeMap(currency);
  return new Intl.NumberFormat(language, {
    style: 'currency',
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}
